// extracted by mini-css-extract-plugin
module.exports = {"disc":"PrivacyPolicy_disc__3QtOF","title":"PrivacyPolicy_title__ma7bE"};